export var CallTrackingStatus;
(function (CallTrackingStatus) {
    CallTrackingStatus["IDLE"] = "idle";
    CallTrackingStatus["LOADING"] = "loading";
    CallTrackingStatus["SUCCESS"] = "success";
    CallTrackingStatus["ERROR"] = "error";
    CallTrackingStatus["DISABLED"] = "disabled";
})(CallTrackingStatus || (CallTrackingStatus = {}));
